import AvatarOriginal from './Avatar';
import AvatarGroup from './avatar-group';

export type { AvatarBorderColor, AvatarProperties, AvatarSize } from './Avatar';
export type { AvatarGroupProperties } from './avatar-group';

const Avatar = Object.assign(AvatarOriginal, { Group: AvatarGroup });

export { Avatar };
